module.exports = __webpack_public_path__ + "img/Lithuania.ce94149e.svg";